import { prop } from "vue-class-component";

import { IPriceEvolution } from "@/models";

export default class PriceEvolutionModalProps {
    priceEvolution: IPriceEvolution = prop({
        required: true,
    });
}
